module.exports = new __parcel__URL__("yo.ad827e91.png").toString();